import * as Logger from "js-logger";

/**
 * This is necessary in order to ensure we only have to configure one logger
 * instance in the case that a local, or npm linked, version of slotworks is
 * being used by a game. (This would be necessary because each project with it's
 * own node_modules would have it's own instance of logger.)
 */
export const logger = Logger;
